import React from "react";
import Price from "../../components/Price";

function Pricelist({ content }) {
  if (!content?.price_list) return null;
  return (
    <Price>
      <Price.Header
        content={content.header}
      />
      <Price.List>
        {content.price_list.map((item, index) => (
          <Price.Item
            key={index}
            content={item}
          />
        ))}
      </Price.List>
    </Price>
  );
}

export default Pricelist;
